module.exports = __webpack_public_path__ + "img/radiateur_a_eau.5c2148d.svg";